module.exports = __webpack_public_path__ + "static/media/se.fe725901.svg";